module.exports = __webpack_public_path__ + "static/images/banner2_b95af1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner2.png
// module id = 221
// module chunks = 1